import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography } from '@mui/material';
import { styled } from '@mui/system';

const CustomDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: '15px',
    padding: theme.spacing(2),
    boxShadow: '0 3px 5px rgba(0,0,0,0.3)',
    color: 'black',
  },
}));

const CancelButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#2196f3',
  color: 'white',
  '&:hover': {
    backgroundColor: '#0056b3',
  },
}));

const CustomButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#f44336',
  color: 'white',
  '&:hover': {
    backgroundColor: '#d32f2f',
  },
}));

const ConfirmWindow = ({ open, title, message, onConfirm, onCancel }) => {
  return (
    <CustomDialog
      open={open}
      onClose={onCancel}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
    >
      <DialogTitle id="custom-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="custom-dialog-description">
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={onConfirm} autoFocus>
          Confirm
        </CustomButton>
        <CancelButton onClick={onCancel}>
          Cancel
        </CancelButton>
      </DialogActions>
    </CustomDialog>
  );
};

export default ConfirmWindow;
